import {handleActions} from 'redux-actions'
import {updateGeoInfo, updateGeoSuggest} from './actions'

export const initialState = {
  cache: {},
  suggest: []
}

export default handleActions(
  {
    [updateGeoInfo](state, {payload}) {
      const id = payload ? parseInt(payload.id, 10) : null

      if (!id) {
        return state
      }

      return {
        ...state,
        cache: {
          ...state.cache,
          [id]: payload ? payload.name : null
        }
      }
    },

    [updateGeoSuggest](state, {payload}) {
      if (payload == null) {
        return {
          ...state,
          suggest: []
        }
      }

      return {
        ...state,
        suggest: Object.keys(payload)
          .map((key) => ({
            ...payload[key],
            id: parseInt(payload[key].id, 10)
          }))
          .sort((a, b) => a.weight - b.weight)
          .slice(0, 10)
      }
    }
  },
  initialState
)
